import axios from 'axios';
import { API_url } from '../api.setup';
import { SalesPartnerPaymentModel } from 'src/models/salesPartner/SalesPartnerPaymentModel';

const API_Controller = '/SalesPartnerPayment';

export const SalesPartnerPaymentServices = {
  getAllData: async (spId: number) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getBySalesPartnerId`, {
        params: { salesPartnerId: spId },
      });
      return response.data as SalesPartnerPaymentModel[];
    } catch (error) {
      console.error('Error fetching payment data:', error);
      throw error;
    }
  },

  addData: async (data: SalesPartnerPaymentModel) => {

    try {
      const response = await axios.post(`${API_url}${API_Controller}`, data);
      return response.data as SalesPartnerPaymentModel;
    } catch (error) {
      console.error("Error adding payment:", error.response?.data || error);
      throw error;
    }
  },

  updateData: async (data: SalesPartnerPaymentModel) => {
    try {
      const response = await axios.put(`${API_url}${API_Controller}/update`, data);
      return response.data as SalesPartnerPaymentModel;
    } catch (error) {
      console.error("Error updating payment:", error);
      throw error;
    }
  },

  getPaymentsBySalesPartnerIdAndDateRange: async (
    salesPartnerId: number,
    startDate: string,
    endDate: string
  ) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getPaymentsBySalesPartnerIdAndDateRange`,
        { params: { salesPartnerId, startDate, endDate } }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching sales partner payments:", error);
      throw error;
    }
  },

};
